export const Colors = {
  primary: {
    hslBlue: "#007ac9",
    hslBlueDark: "#0062a1",
    hslGrey: "#888888",
    hslGreyLight: "#b7b7b7",
    hslGreyLight2: "#bbbbbb",
    hslGreyXLight: "#dddddd",
    hslGreyDark: "#333333",
    hslGreyDove: "#666666",
    hslWhite: "#ffffff",
  },
  secondary: {
    hslOrange: "#ff6319",
    hslOrangeDark: "#BF4A13",
    hslMagenta: "#dc0451",
    hslMagentaLight: "#fff6f6",
    hslPurple: "#8c4799",
    hslPurpleDark: "#693573",
    hslYellow: "#fed100",
    hslYellowDark: "#967B00",
    hslPink: "#f092cd",
    hslPinkDark: "#F653B9",
    hslCyan: "#00B9E4",
    hslCyanDark: "#008BAB",
    hslGreen: "#4ea700",
    hslGreenLight: "#64be14",
    hslGreenDark: "#3b7f00",
    hslGreyBlue: "#6ca4b0",
  },
  background: {
    hslWhite: "#ffffff",
    hslBlueLight: "#eff9ff",
    hslGreyDark: "#333333",
    hslGreyLight: "#eef1f3",
    hslGreyXLight: "#e4e4e4",
    hslGreyXXLight: "#f4f4f5",
  },
  // Don't use following transportation colors out of context of transportation icons etc.
  // You'll break your app's theming eventually if you do so
  // You can find same colors from above categories
  // If you need to, add some custom colors of your own to theme instead
  transport: {
    bus: "#0079c9",
    trunk: "#0079c9",
    rail: "#8b4799",
    tram: "#00985f",
    subway: "#ff621a",
    metro: "#ff621a",
    ferry: "#01b9e4",
    bike: "#fbb800",
  },
};
